import React, { InputHTMLAttributes, useState } from 'react';
import cn from 'classnames';
import styles from './input.module.scss';

type Props = InputHTMLAttributes<HTMLInputElement>;

export const Input: React.FC<Props> = ({ className, ...rest }) => {
    return <input {...rest} className={cn(styles.input, className)} />;
};
